module.exports = __webpack_public_path__ + "static/media/us.a1454bbb.svg";